export default __webpack_public_path__ + "static/media/skipTime.34a622fb.png";